import { render } from "./ReportGeofence.vue?vue&type=template&id=5cc4c1bc"
import script from "./ReportGeofence.vue?vue&type=script&lang=js"
export * from "./ReportGeofence.vue?vue&type=script&lang=js"
script.render = render

export default script